import { Box, styled } from "@mui/material";

export const CollapseButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isCollapsed",
})<{ $isCollapsed: boolean }>(({ theme, $isCollapsed }) => ({
  position: "absolute",
  top: 30,
  right: -11, // Position on the right border edge
  zIndex: 250, // Higher than sidebar (200) to sit above content area
  opacity: $isCollapsed ? 1 : 0, // Always visible when collapsed, hidden when expanded (unless hovered)
  transition: "opacity 0.2s ease-in-out, background-color 0.2s ease-in-out",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "50%",
  boxShadow: "rgba(9, 30, 66, 0.08) 0px 0px 0px 1px, rgba(9, 30, 66, 0.08) 0px 2px 4px 1px",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    "& .MuiIconButton-root": {
      color: theme.palette.common.white,
    },
  },
}));
